import React from "react";
import "./PageContentHeader.css";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { Breadcrumbs, Box, Link, Tabs, Tab } from "@mui/material";
import { headerOptionsRoutes } from "../../utils/routes";
import DateFilterSaveOptions from "../DateFilterSaveOptions/DateFilterSaveOptions";
import { capitalizeFirstLetter } from "../../utils/utils";
import { AppColors } from "../../utils/colors";
import { useHomeTab, HOME_TABS, HOME_TABS_DISABLED } from "../../modules/dashboard/Home/homeTabContext";

const TABS_PAGES = ["/dashboard/home", "/dashboard/history"];

const PageContentHeader = (props) => {
  const { pathname } = useLocation();
  const isTabsPage = TABS_PAGES.includes(pathname);

  return (
    <Box className="page-content-header-container">
      {isTabsPage ? <HomeTabsHeader /> : <HeaderBreadCrumbs />}
      {headerOptionsRoutes.includes(pathname) && (
        <Box>
          <DateFilterSaveOptions />
        </Box>
      )}
    </Box>
  );
};

const HomeTabsHeader = () => {
  const { activeTab, setActiveTab } = useHomeTab();
  const { pathname } = useLocation();
  const pageTitle = pathname === "/dashboard/history" ? "History" : "Dashboard";

  return (
    <Box>
      <span style={{ fontSize: 30, display: "block", marginBottom: 15 }}>{pageTitle}</span>
      <Tabs
        value={activeTab}
        onChange={(_, newValue) => setActiveTab(newValue)}
        sx={{ borderBottom: 1, borderColor: "divider", minHeight: "unset" }}
      >
        {HOME_TABS.map((label, i) => (
          <Tab
            key={i}
            label={label}
            disableRipple
            disabled={HOME_TABS_DISABLED[i]}
            sx={{
              textTransform: "none",
              fontSize: 14,
              minHeight: "unset",
              padding: "4px 16px",
              color: AppColors.grey.secondary,
              "&.Mui-selected": { color: "#000"},
              "&.Mui-disabled": { color: AppColors.grey.secondary, opacity: 1 },
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

const HeaderBreadCrumbs = () => {
  const { pathname } = useLocation();
  const pathSegments = pathname.split("/").filter((segment) => segment);
  const currPageName = capitalizeFirstLetter(
    pathSegments[pathSegments.length - 1]
  );

  return (
    <Box>
      <span style={{ fontSize: 30 }}>{currPageName}</span>
      <br />
      <Breadcrumbs>
        {pathSegments.map((segment, index) => {
          const path = `/${pathSegments.slice(0, index + 1).join("/")}`;
          const displayText = capitalizeFirstLetter(segment);
          return (
            <Link
              key={path}
              component={RouterLink}
              to={path}
              sx={{ color: AppColors.grey.secondary, textDecoration: "none" }}
            >
              {displayText}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default PageContentHeader;
